module.exports = __webpack_public_path__ + "static/media/LAMBDA.a6f85a0c.svg";